<!-- "More info" dropdown for a goal's `info` text (ZiLL descriptions, GO! Navigator
     examples and MIA info lines). The text is plain, pre-wrapped — the mapper folds
     headings and bullet lines into it with newlines.
     The panel is teleported (see Dropdown.v2) so a drawer's overflow can't clip it. -->
<template>
	<div class="relative inline-block">
		<div tabindex="0" role="button" class="btn-more-info" @click="open">
			{{ $t("More info") }}
		</div>

		<Dropdown ref="popover" position="top-end" class="w-96 max-w-[90vw]" teleport>
			<div
				class="card shadow ring-1 ring-inset ring-base-200 bg-base py-2 px-4 whitespace-pre-wrap text-left font-normal"
				v-text="info"
			></div>
		</Dropdown>
	</div>
</template>

<script lang="ts">
import Dropdown from "@/components/ui/Dropdown.v2.vue";

export default {
	components: {
		Dropdown,
	},

	props: {
		info: {
			type: String,
			required: true,
		},
	},

	methods: {
		open() {
			(this.$refs.popover as InstanceType<typeof Dropdown>).open();
		},
	},
};
</script>
